import GridContainer from "../../../../../Components/ReportFormTemplate/GridContainer";
import {
   Card,
   Divider,
   Heading,
   Paragraph,
   Popover,
} from "@nn-design-system/react-component-library";
import InsuredRelationshipField from "./PersonThroutfulFields/InsuredRelevationshipField";
import ThroutfulPersonAddressField from "./PersonThroutfulFields/ThroutfulPersonAddressField";
import ThroutfulPersonEmailField from "./PersonThroutfulFields/ThroutfulPersonEmailField";
import ThroutfulPersonFirstnameField from "./PersonThroutfulFields/ThroutfulPersonFirstnameField";
import ThroutfulPersonLastnameField from "./PersonThroutfulFields/ThroutfulPersonLastnameField";
import ThroutfulPersonIsForeignerField from "./PersonThroutfulFields/ThroutfulPersonIsForeignerField";
import ThroutfulPersonPersonalIdField from "./PersonThroutfulFields/ThroutfulPersonPersonalIdField";
import ThroutfulPersonPhoneNumberField from "./PersonThroutfulFields/ThroutfulPersonPhoneNumberField";
import ThroutfulPersonPlaceOfBirthField from "./PersonThroutfulFields/ThroutfulPersonPlaceOfBirthField";
import WholeLineContainer from "../../../../../Components/ReportFormTemplate/WholeLineContainer";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../redux/store/store";
import ThroutfulPersonPostCodeField from "./PersonThroutfulFields/ThroutfulPersonPostCodeField";
import ThroutfulPersonCountryField from "./PersonThroutfulFields/ThroutfulPersonCountryField";
import ThroutfulPersonCityField from "./PersonThroutfulFields/ThroutfulPersonCityField";
import ThroutfulPersonIsContactAddressDifferent from "./PersonThroutfulFields/ThroutfulPersonIsContactAdressDifferentField";
import ThroutfulPersonContactAddressField from "./PersonThroutfulFields/ThroutfulPersonContactAddressField";
import ThroutfulPersonContactCityField from "./PersonThroutfulFields/ThroutfulPersonContactCityField";
import ThroutfulPersonContactPostCodeField from "./PersonThroutfulFields/ThroutfulPersonContactPostCode";
import ThroutfulPersonIsMinor from "./PersonThroutfulFields/ThroutfulPersonIsMinor";
import ThroutfulPersonCitizenshipField from "./PersonThroutfulFields/ThroutfulPersonCitizenshipField";
import ThroutfulPersonChildFirstnameField from "./PersonThroutfulFields/ThroutfulPersonChildFirstname";
import ThroutfulPersonChildLastnameField from "./PersonThroutfulFields/ThroutfulPersonChildLastname";
import ThroutfulPersonChildPersonalIdField from "./PersonThroutfulFields/ThroutfulPersonChildPersonalId";
import IdentificationDataBlock from "../../../../../Components/IdentificationDataBlock/IdentificationDataBlock";
import { updateSecondStepGeneralsNestedFields } from "../../../../../redux/reducers/claimReducer";

const PersonThroutfulSection = () => {
   const dispatch = useDispatch();
   const isMinor = useSelector(
      (state: StoreType) =>
         state.claimState.personModel.personThroutful.throutfulPersonIsMinor
   );

   const { selectedTypeOfClaims } = useSelector(
      (state: StoreType) => state.claimState
   );

    const isDeathClaim = selectedTypeOfClaims.some((claim) => claim === "death");
    const authStatus = useSelector(
       (state: StoreType) => state.authState.userAuthenticationStatus
    );
     const personThroutful = useSelector(
        (state: StoreType) => state.claimState.personModel.personThroutful
     );
     const claimFieldErrorsMessages = useSelector(
        (state: StoreType) => state.claimFieldErrorsState
     );

   if (!isDeathClaim) {
      return null;
   }

   return (
      <Card mt="2rem">
         <GridContainer>
            <WholeLineContainer>
               <>
                  <>
                     <Heading hasMargin={false} variant="Large">
                        Údaje o obmyšlené osobě
                     </Heading>
                     <Paragraph hasMargin={false} mt="1rem">
                        Obmyšlenou osobou je ten, kdo byl pojištěným zvolen jako
                        příjemce plnění v případě jeho úmrtí. Pokud probíhá
                        dědické řízení, může to být i soudem určená osoba.
                     </Paragraph>
                  </>
               </>
            </WholeLineContainer>

            <WholeLineContainer>
               <>
                  <Heading
                     variant={"Medium"}
                     hasMargin={false}
                     mb=".5rem"
                     mt="1rem"
                  >
                     Vztah k zemřelé(mu)
                  </Heading>
                  <Divider variant="Brand"></Divider>
               </>
            </WholeLineContainer>

            <InsuredRelationshipField />
            <ThroutfulPersonIsMinor />

            {isMinor && (
               <>
                  <WholeLineContainer>
                     <>
                        <Heading
                           variant={"Medium"}
                           hasMargin={false}
                           mb=".5rem"
                           mt="1rem"
                        >
                           Osobní údaje nezletilé obmyšlené osoby
                        </Heading>
                        <Divider variant="Brand"></Divider>
                        {/* {isMinor && (
                           <Paragraph mt="1rem" hasMargin={false}>
                              Peníze nemůžeme vyplatit nezletilému. Proto
                              potřebujeme doplnit údaje zákonného zástupce (nebo
                              opatrovníka), kterému prostředky pošleme.
                           </Paragraph>
                        )} */}
                     </>
                  </WholeLineContainer>
                  <ThroutfulPersonChildFirstnameField />
                  <ThroutfulPersonChildLastnameField />
                  <ThroutfulPersonChildPersonalIdField />
               </>
            )}

            <WholeLineContainer>
               <>
                  <Heading
                     variant={"Medium"}
                     hasMargin={false}
                     mb=".5rem"
                     mt="1rem"
                  >
                      {isMinor
                         ? "Osobní údaje zákonného zástupce obmyšlené osoby"
                         : "Osobní údaje obmyšlené osoby"}
                   </Heading>
                   {authStatus === "agent" && isMinor && (
                      <Popover placement="top-start" variant="Icon">
                         <Paragraph>
                            V případě pojistného plnění v celkové hodnotě 25 000 Kč a více zákonnému zástupci dítěte pojišťovna může vyžadovat doložení dokladu, který jej opravňuje k zastupování (rodný list dítěte, občanský průkaz se zápisem dítěte, či rozhodnutí soudu).
                         </Paragraph>
                      </Popover>
                   )}
                  <Divider variant="Brand"></Divider>
                  {isMinor && (
                     <Paragraph mt="1rem" hasMargin={false}>
                        Peníze nemůžeme vyplatit nezletilému. Proto potřebujeme
                        doplnit údaje zákonného zástupce (nebo opatrovníka),
                        kterému prostředky pošleme.
                     </Paragraph>
                  )}
               </>
            </WholeLineContainer>

            <ThroutfulPersonFirstnameField />
            <ThroutfulPersonLastnameField />
            <ThroutfulPersonPlaceOfBirthField />
            <ThroutfulPersonPersonalIdField />
            <ThroutfulPersonIsForeignerField />
            <ThroutfulPersonCitizenshipField />

             {authStatus === "agent" && (
                <IdentificationDataBlock
                   checked={personThroutful.throutfulPersonPerformAmlIdentification}
                   identityCardType={personThroutful.throutfulPersonIdentityCardType}
                   identityCardNumber={personThroutful.throutfulPersonIdentityCardNumber}
                   identityCardIssuedBy={personThroutful.throutfulPersonIdentityCardIssuedBy}
                   identityCardValidUntil={personThroutful.throutfulPersonIdentityCardValidUntil}
                   updateField={(field, value) =>
                      dispatch(
                         updateSecondStepGeneralsNestedFields({
                            sectionName: "personThroutful",
                            field:
                               field === "checked"
                                  ? "throutfulPersonPerformAmlIdentification"
                                  : `throutfulPerson${field.charAt(0).toUpperCase()}${field.slice(1)}`,
                            value,
                         })
                      )
                   }
                   validationKeys={{
                      identityCardType: "ThroutfulPersonIdentityCardType",
                      identityCardNumber: "ThroutfulPersonIdentityCardNumber",
                      identityCardIssuedBy: "ThroutfulPersonIdentityCardIssuedBy",
                      identityCardValidUntil: "ThroutfulPersonIdentityCardValidUntil",
                   }}
                   helperText={
                      isMinor
                         ? "Pokud očekávaná výše pojistného plnění přesahuje 25 000 Kč, vyplňte prosím část „Doplnit identifikační údaje“ podle platného průkazu totožnosti zákonného zástupce."
                         : "Pokud očekávaná výše pojistného plnění přesahuje 25 000 Kč, vyplňte prosím část „Doplnit identifikační údaje“ podle platného průkazu totožnosti obmyšlené osoby."
                   }
                   fieldErrors={claimFieldErrorsMessages}
                />
             )}

            <WholeLineContainer>
               <>
                  <Heading
                     variant={"Medium"}
                     hasMargin={false}
                     mb=".5rem"
                     mt="1rem"
                  >
                     Adresa trvalého bydliště
                  </Heading>
                  <Divider variant="Brand"></Divider>
               </>
            </WholeLineContainer>

            <ThroutfulPersonAddressField />
            <ThroutfulPersonCityField />
            <ThroutfulPersonPostCodeField />
            <ThroutfulPersonCountryField />
            <ThroutfulPersonIsContactAddressDifferent />
            <ThroutfulPersonContactAddressField />
            <ThroutfulPersonContactCityField />
            <ThroutfulPersonContactPostCodeField />

            <WholeLineContainer>
               <>
                  <Heading
                     variant={"Medium"}
                     hasMargin={false}
                     mb=".5rem"
                     mt="1rem"
                  >
                     Kontaktní údaje
                  </Heading>
                  <Divider variant="Brand"></Divider>
               </>
            </WholeLineContainer>

            <ThroutfulPersonPhoneNumberField />
            <ThroutfulPersonEmailField />
         </GridContainer>
      </Card>
   );
};

export default PersonThroutfulSection;
